import React from "react";

export interface TableRowProps {
    data: Array<{ label: string | null; values: string[] }>;
}

const TableRow: React.FC<TableRowProps> = ({ data }) => {
    const renderValues = (values: string[]) => {
        if (!values?.length) {
            return null;
        }
        if (values.length === 1) {
            return values[0];
        }
        return values.map((value: string, index: number) => (
            <span key={index} className="display-block">
                {value}
            </span>
        ));
    };
    return (
        <tr className="row">
            <td className="cell">{data[0]?.label}</td>
            <td className="cell">{renderValues(data[0]?.values)}</td>
            {data.length >= 2 && (
                <React.Fragment>
                    <td className="cell">{data[1]?.label}</td>
                    <td className="cell">{renderValues(data[1].values)}</td>
                </React.Fragment>
            )}
            {data.length >= 3 && (
                <React.Fragment>
                    {data[2]?.label !== null && <td className="cell">{data[2]?.label}</td>}
                    <td className="cell">{renderValues(data[2].values)}</td>
                </React.Fragment>
            )}
        </tr>
    );
};

export default TableRow;
